import { ___, partialApply } from '@ipfabric/utils/fp/partialApply';
import { performUndoableAction } from 'components/Graph/commands/history/performUndoableAction';
import type { GraphCommandFactory } from 'components/Graph/model/GraphCommandContext';
import { selectAllEdgesSettings } from 'components/Graph/model/selectors/selectAllEdgesSettings';
import { record } from 'fp-ts';
import { createNodeCollapsingUndoableAction } from './helpers/createNodeCollapsingUndoableAction';
import { uncollapseNodes } from './helpers/uncollapseNodes';

export const uncollapseAllNodes: GraphCommandFactory =
  (cmdContext, dispatch) => () => {
    const originalGraph = cmdContext.getState().graph;
    const allCollapsedNodeIds = new Set(
      record.keys(originalGraph.collapsedNodeGroups),
    );
    dispatch(
      performUndoableAction,
      createNodeCollapsingUndoableAction(
        cmdContext.updateState,
        originalGraph,
        partialApply(
          uncollapseNodes,
          ___,
          selectAllEdgesSettings(cmdContext.getState()),
          allCollapsedNodeIds,
        ),
      ),
    );
  };
